var map = {
	"./login/login.module.ngfactory": [
		"./src/app/auth/login/login.module.ngfactory.js",
		"default~login-login-module-ngfactory~register-register-module-ngfactory",
		"login-login-module-ngfactory"
	],
	"./meals/meals.module.ngfactory": [
		"./src/app/health/meals/meals.module.ngfactory.js",
		"default~meals-meals-module-ngfactory~workouts-workouts-module-ngfactory",
		"meals-meals-module-ngfactory"
	],
	"./register/register.module.ngfactory": [
		"./src/app/auth/register/register.module.ngfactory.js",
		"default~login-login-module-ngfactory~register-register-module-ngfactory",
		"register-register-module-ngfactory"
	],
	"./schedule/schedule.module.ngfactory": [
		"./src/app/health/schedule/schedule.module.ngfactory.js",
		"schedule-schedule-module-ngfactory"
	],
	"./workouts/workouts.module.ngfactory": [
		"./src/app/health/workouts/workouts.module.ngfactory.js",
		"default~meals-meals-module-ngfactory~workouts-workouts-module-ngfactory",
		"workouts-workouts-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;